<div
  class="row pt-3 pb-3 px-2 item pointer-cursor mx-2"
  [ngClass]="{ 'active-item': unitId === sharedData?.selectedUnit?.unitId }"
  (click)="unitClickHandler(unitId, name, floorId, floorName)"
>
  <div class="col-2 text-center">
    <img src="assets/svg/ico-default-home-circle.svg" class="icon" />
  </div>
  <div class="col-8">
    <div class="col-12 heading2">
      <app-with-tooltip [showHelpCursor]="false">{{ name }}</app-with-tooltip>
    </div>
    <div class="col-12 status">{{ unitStatus | titlecase }}</div>
  </div>
  <div
    class="col-1 d-flex flex-column justify-content-center align-items-center"
  >
    <ng-container
      *ngIf="isNonActive || isLockBatteryLow || isLatestFirmwareAvailable"
    >
      <img src="assets/svg/ico-alert-red.svg" alt="alert" />
    </ng-container>
  </div>
  <div
    class="col-1 pr-2 d-flex flex-column justify-content-center align-items-center"
    (click)="unitClickHandler(unitId, name, floorId, floorName)"
  >
    <img src="assets/svg/ico-chevron-forward-outline.svg" />
  </div>
</div>
